import {memo} from 'react';
import TextInput from '@/components/Common/TextInput';
import SingleSelect from '@/components/Common/SingleSelect';

const FormControlType = (props: any): any => {
    const {control, ...rest} = props;

    switch (control) {
        case 'text':
            return <TextInput {...rest} />;

        case 'select':
            return <SingleSelect {...rest} />;
        default:
            return null;
    }
};
export default memo(FormControlType);
